import { createFileRoute, redirect } from '@tanstack/react-router';
import { getDefaultPeriod } from '@/features/contract-and-cost/period';
export const Route = createFileRoute('/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/payment/')({
  beforeLoad: () => {
    throw redirect({
      to: '/devices/contract-and-cost/payment/$period',
      params: {
        period: getDefaultPeriod()
      }
    });
  }
});